import React, { memo, useMemo } from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { sharedStyles, sharedFontStyle } from '../sharedStyles';

interface DivCssProps {
  sharedStyles: SerializedStyles;
  secondaryBtnBg: string;
}

interface SpanCssProps {
  sharedFontStyle: SerializedStyles;
  secondaryBtnTxt: string;
}

interface OutlinedSecondaryButtonProps {
  secondaryBtnBg: string;
  secondaryBtnTxt: string;
}

const Div = styled.div`
  ${({ sharedStyles, secondaryBtnBg }: DivCssProps) => css`
    ${sharedStyles};
    background-color: #ffffff;
    padding: 12px 16px;
    border: 2px solid ${secondaryBtnBg};
  `}
`;
const Span = styled.span`
  ${({ sharedFontStyle, secondaryBtnTxt }: SpanCssProps) => css`
    ${sharedFontStyle};
    color: ${secondaryBtnTxt};
  `}
`;

const OutlinedSecondaryButton: React.FC<OutlinedSecondaryButtonProps> = ({
  secondaryBtnBg,
  secondaryBtnTxt,
}) => {
  const divCssProps = useMemo(
    () => ({
      sharedStyles,
      secondaryBtnBg,
    }),
    [secondaryBtnBg]
  );

  const spanCssProps = useMemo(
    () => ({
      sharedFontStyle,
      secondaryBtnTxt,
    }),
    [secondaryBtnTxt]
  );

  return (
    <Div {...divCssProps}>
      <Span {...spanCssProps}>查看更多</Span>
    </Div>
  );
};

export default memo(OutlinedSecondaryButton);
